import { AlpineComponent } from '@alpinejs/csp';

const MainStage = (): AlpineComponent => ({
  index: undefined,
  backgroundSize: 10,
  maxIndex: 0,
  interval: undefined,
  animationInProgress: false,
  animationDuration: 6000,
  init() {
    this.index = 0;
    this.maxIndex = Number(this.$root.getAttribute('data-max-index'));

    this.updateInterval();
    this.animateBackgroundSize(10, 6000);
  },
  isActive() {
    return this.index === Number(this.$el.dataset.index);
  },
  getDotStyle() {
    const isCurrentIndex = Number(this.$el.dataset.index) === this.index;

    return `background-size: ${
      isCurrentIndex ? this.backgroundSize : 100
    }% 100%;`;
  },
  getTriggerClassName() {
    return Number(this.$el.dataset.index) === this.index
      ? 'tag-parent--active'
      : '';
  },
  updateInterval() {
    if (this.interval) clearInterval(this.interval);

    this.interval = setInterval(() => {
      this.nextItem();
      this.startAnimation();
    }, this.animationDuration);

    this.startAnimation();
  },
  nextItem() {
    this.backgroundSize = 10;
    this.index = this.index + 1 > this.maxIndex ? 0 : this.index + 1;
  },
  updateItem(e: any) {
    const index = Number(e.currentTarget.getAttribute('data-index'));
    this.updateInterval();
    this.index = index;
  },

  startAnimation() {
    const startTime = performance.now();
    const endTime = startTime + this.animationDuration;

    this.animateBackgroundSize(10, 100, startTime, endTime);
  },

  animateBackgroundSize(
    startValue: number,
    endValue: number,
    startTime: number,
    endTime: number
  ) {
    const animateStep = (currentTime: number) => {
      if (currentTime < endTime) {
        const progress = (currentTime - startTime) / this.animationDuration;
        this.backgroundSize = (
          startValue +
          (endValue - startValue) * progress
        ).toFixed(2);
        requestAnimationFrame(animateStep);
      }
    };

    requestAnimationFrame(animateStep);
  }
});

export default MainStage;
